import { apiClient } from '@/core/api/client';
import type { Report } from '../types/reports.types';

interface FetchReportsParams {
  clientId: string;
}

interface ReportsResponse {
  success: boolean;
  data: {
    reports: Report[];
    pagination: {
      current_page: number;
      total_pages: number;
      total_items: number;
      items_per_page: number;
      has_next: boolean;
      has_previous: boolean;
    };
    filters_applied: Record<string, any>;
  };
  timestamp: string;
}

export const reportsApi = {
  /**
   * Fetches reports list for a specific client
   * @param params - Query parameters including required clientId
   * @returns Promise with reports array and pagination info
   */
  fetchReports: async (params: FetchReportsParams): Promise<ReportsResponse> => {
    if (!params.clientId) {
      throw new Error('client_id is required');
    }

    try {
      const response = await apiClient.get(`/api/banque/reports/${params.clientId}`);
      // apiClient.get already extracts .data from axios response
      // So 'response' here is already the backend's response body
      // Backend returns: { success: true, data: { reports: [...], pagination: {...} }, timestamp: ... }
      return response as ReportsResponse;
    } catch (error) {
      console.error('Error fetching reports:', error);
      throw error;
    }
  }
};